import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";
import { SectionHeader } from "@/components/ui-bits";
import { Reveal } from "@/components/motion-primitives";

const whatsappUrl = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi SML Municipal Consulting, I'd like assistance with my municipal account.")}`;
const mapSrc = "https://www.google.com/maps?q=134+River+Road,+Barbeque+Downs,+Kyalami,+South+Africa&output=embed";

const Item = ({ icon: Icon, label, value, href, testId }) => (
  <a
    href={href} data-testid={testId} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
    className="group flex items-start gap-4 rounded-xl border border-slate-200/80 bg-white px-5 py-5 hover:border-secondary/50 hover:shadow-md transition-all duration-300"
  >
    <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary text-white group-hover:bg-secondary transition-colors shrink-0">
      <Icon className="w-5 h-5" />
    </span>
    <span className="leading-tight">
      <span className="block text-xs uppercase tracking-wider text-muted-foreground">{label}</span>
      <span className="block mt-1 font-semibold text-primary group-hover:text-secondary transition-colors">{value}</span>
    </span>
  </a>
);

export const Contact = () => (
  <section id="contact" className="relative py-24 md:py-32 bg-muted/40">
    <div className="container mx-auto px-4 md:px-8">
      <SectionHeader
        overline="Contact"
        title="Contact SML Municipal Consulting"
        subtitle="Call, email or send a WhatsApp — or complete the quote form and we'll come back to you within 48 hours."
      />

      <div className="mt-14 grid lg:grid-cols-2 gap-10">
        <div className="grid sm:grid-cols-2 gap-4">
          <Item icon={Phone} label="Telephone" value={CONTACT.phone} href={`tel:${CONTACT.phoneRaw}`} testId="contact-call" />
          <Item icon={MessageCircle} label="WhatsApp" value={CONTACT.phone} href={whatsappUrl} testId="contact-whatsapp" />
          <Item icon={Mail} label="Email" value="info@smlmunicipalconsulting.co.za" href={`mailto:${CONTACT.email}`} testId="contact-email" />
          <Item icon={MapPin} label="Address" value="134 River Road, Kyalami" href={mapSrc.replace("&output=embed", "")} testId="contact-map-link" />
          <div className="sm:col-span-2 rounded-xl border border-slate-200/80 bg-white p-5">
            <div className="text-xs uppercase tracking-wider text-muted-foreground">Office Address</div>
            <address className="mt-2 not-italic text-primary font-medium leading-relaxed">
              {CONTACT.addressLines.map((l) => <span key={l} className="block">{l}</span>)}
            </address>
          </div>
        </div>

        <Reveal>
          <div className="rounded-2xl overflow-hidden border border-slate-200/80 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)] h-full min-h-[380px]">
            <iframe
              title="SML Municipal Consulting location"
              src={mapSrc}
              className="w-full h-full min-h-[380px]"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="google-map"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
